import React, { FC, memo } from 'react';

import { DATA_TEST_IDS } from '../../consts';
import { TEXTS } from '../../texts';
import ReportSelectionHeader from '../../ReportSelectionHeader';

import styles from './index.module.scss';

type PromoSelectionHeaderProps = {
  selectedCount: number;
  onReset: () => void;
};

const PromoSelectionHeader: FC<PromoSelectionHeaderProps> = ({ selectedCount, onReset }) => (
  <ReportSelectionHeader
    className={styles.header}
    resetAction={{
      isDisabled: selectedCount === 0,
      testId: DATA_TEST_IDS.AUDIO_REPORT_PROMOS_RESET,
      text: TEXTS.AUDIO_REPORT_PROMOS_RESET,
      onClick: onReset,
    }}
    selectedCount={TEXTS.AUDIO_REPORT_PROMOS_SELECTED_COUNT(selectedCount)}
    selectedCountTestId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_SELECTED_COUNT}
    testId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_SELECTION_HEADER}
  />
);

export default memo(PromoSelectionHeader);
